export async function getFileSHA256(base64String) {
    console.log("base64String", base64String);
    if (base64String?.includes("base64")) {
        const binaryString = atob(base64String.split(',')[1]);
        const binaryArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            binaryArray[i] = binaryString.charCodeAt(i);
        }


        const hashBuffer = await crypto.subtle.digest('SHA-256', binaryArray);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    }
    return "";
}